import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AVATAR_FIELDS,
    NAME_FIELDS,
    GENDER_FIELDS,
    AVATAR_GENDER_CLASSES,
    AVATAR_SIZES,
    AvatarSize
} from './avatar.constants';

@Component({
    selector: 'spotlight-avatar',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightAvatarComponent {
    @Input() data: any = {};
    @Input() size: AvatarSize = 'sm';
    @Input() rounded: 'full' | 'xl' = 'full';

    /**
     * Obtém a URL da foto do membro
     */
    getPhoto(): string | null {
        for (const field of AVATAR_FIELDS) {
            if (this.data[field]) {
                return this.data[field];
            }
        }
        return null;
    }

    /**
     * Obtém o nome do membro
     */
    getName(): string {
        for (const field of NAME_FIELDS) {
            if (this.data[field]) {
                return this.data[field];
            }
        }
        return '';
    }

    /**
     * Obtém as iniciais do nome
     */
    getInitials(): string {
        const name = this.getName();
        if (!name) return '?';

        const parts = name.trim().split(' ').filter(p => p.length > 0);
        if (parts.length === 0) return '?';

        if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }

        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }

    /**
     * Obtém as classes CSS baseadas no gênero
     */
    getGenderClasses(): string {
        for (const field of GENDER_FIELDS) {
            const gender = this.data[field];
            if (gender === 'male') return AVATAR_GENDER_CLASSES.male;
            if (gender === 'female') return AVATAR_GENDER_CLASSES.female;
        }
        return AVATAR_GENDER_CLASSES.default;
    }

    /**
     * Obtém as classes de tamanho
     */
    getSizeClasses(): string {
        return AVATAR_SIZES[this.size];
    }

    /**
     * Obtém a classe de arredondamento
     */
    getRoundedClass(): string {
        return this.rounded === 'full' ? 'rounded-full' : 'rounded-xl';
    }

    /**
     * Handler para erro de carregamento de imagem
     */
    onImageError(): void {
        // Remove a foto dos campos conhecidos para mostrar as iniciais
        for (const field of AVATAR_FIELDS) {
            if (this.data[field]) {
                this.data[field] = null;
            }
        }
    }
}
